import React from 'react';
import { CheckCircle2Icon, CreditCardIcon } from 'lucide-react';
import { creditReference } from '../../data/loan';
import type { RunMode } from '../../types/aus';
import { DetailGroup, DetailRow, SummaryCard } from './SummaryCard';
interface CreditCardProps {
  mode: RunMode;
  onEditReference: () => void;
}
export function CreditCard({
  mode,
  onEditReference
}: CreditCardProps) {
  const showRequestType = mode !== 'fannie';
  const title = mode === 'freddie' ? 'Credit Reference' : 'Credit Information';
  const confirmation = mode === 'freddie' ? 'Credit report linked' : 'Credit reference found';
  return <SummaryCard title={title} icon={CreditCardIcon} action={<button type="button" onClick={onEditReference} className="rounded-lg px-2 py-1 text-xs font-medium text-slate-500 underline-offset-2 transition-colors hover:text-slate-900 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900" data-id="element-46" data-mp="3s78ol0x126w4">
          Edit credit reference
        </button>} data-id="element-45" data-mp="3o6yb736woe78">
      <div className="grid gap-6 sm:grid-cols-2 sm:gap-8" data-id="element-47" data-mp="2kfr9tdofa4xw">
        <DetailGroup label="Report" data-id="element-48" data-mp="2fg4w734ommok">
          <DetailRow label="Credit Provider" value={creditReference.provider} data-id="element-49" data-mp="2fh68faxfpf7v" />
          <DetailRow label="Borrower" value={creditReference.borrower} data-id="element-50" data-mp="2tfxjspkwwmsb" />
          <DetailRow label="Reference Number" value={creditReference.referenceNumber} data-id="element-51" data-mp="2pby4gabdbu0j" />
        </DetailGroup>
        <DetailGroup label="Details" data-id="element-52" data-mp="33bhc7209p3cb">
          <DetailRow label="Report Type" value={creditReference.reportType} data-id="element-53" data-mp="33afr04pjf0gv" />
          {showRequestType && <DetailRow label="Request Type" value={creditReference.requestType} data-id="element-54" data-mp="2ybuykrgj1l2z" />}
          <DetailRow label="Credit Bureaus" value={creditReference.bureaus.join(' · ')} data-id="element-55" data-mp="3d1sl72yt62q2" />
          <DetailRow label="Ordered" value={creditReference.orderedOn} data-id="element-56" data-mp="3840olvn7xsfj" />
        </DetailGroup>
      </div>

      <div className="mt-4 flex items-start gap-2.5 rounded-xl bg-emerald-50 px-4 py-3" data-id="element-57" data-mp="3m3jlttehrjd2">
        <CheckCircle2Icon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" data-id="element-58" data-mp="3h5rx18958dd3" />
        <div data-id="element-59" data-mp="2esc28axeyeza">
          <p className="text-sm font-semibold text-emerald-800" data-id="element-60" data-mp="2eoobtkn9m8os">{confirmation}</p>
          <p className="text-sm text-emerald-700" data-id="element-61" data-mp="2jqdkwuqxgca8">
            {mode === 'dual' ? 'One credit report is reused for both Fannie Mae and Freddie Mac.' : 'Credit information was automatically matched from the loan file.'}
          </p>
        </div>
      </div>
    </SummaryCard>;
}